import { render, staticRenderFns } from "./StandardizedDropdown.vue?vue&type=template&id=8ae2f57e&scoped=true"
import script from "./StandardizedDropdown.vue?vue&type=script&lang=js"
export * from "./StandardizedDropdown.vue?vue&type=script&lang=js"
import style0 from "./StandardizedDropdown.vue?vue&type=style&index=0&id=8ae2f57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae2f57e",
  null
  
)

export default component.exports